import * as Sentry from "@sentry/react";
import { isTelemetryEnabled } from "./env";

export function identifyUser(userId: string | undefined | null) {
  if (!isTelemetryEnabled()) return;

  if (!userId) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({ id: userId });
}
